var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.87,
    height: 31.15,
    viewBox: "0 0 72.87 31.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "43.88 3.61 39.36 3.61 39.36 20.91 43.88 20.92 43.88 3.61",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.15 3.61 44.63 3.61 44.63 20.93 49.15 20.94 49.15 3.61",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.63 26.57 49.15 26.57 49.15 21.63 44.63 21.62 44.63 26.57",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.36 26.57 43.88 26.57 43.88 21.62 39.36 21.61 39.36 26.57",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29,20.81c-.09,0-.18,.05-.23,.13l-.1,.17c-.11,.18,.02,.4,.22,.4l37.18,.1v-.7l-37.07-.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.88 20.92 43.88 21.62 44.63 21.62 44.63 20.93 43.88 20.92",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,11.96l.24,4.96c0,.14,.12,.24,.25,.25l8.1,.41v-.35l-.21-2.37c-.61-.93-3.25-2.92-3.49-3.11-.01-.01-.02-.02-.04-.03-1.02-.54-4.47-.48-4.47-.48h0c-.52,.06-.47,.49-.4,.61,.02,.03,.02,.06,.02,.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,20.17s-.03-.02-.05-.02c-.39-.13-.7,.02-.86,.13-.07,.05-.11,.13-.11,.21l-.06,2.94c0,.13,.09,.25,.23,.27,.51,.06,1.19-.2,1.19-.2h0c.28-.35,.21-1.53,.21-1.53,0-1.39-.43-1.73-.54-1.8Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.86,21.15c-.04-.1-.14-.16-.24-.16l-19.47-.05v.7l19.54,.05c.19,0,.32-.19,.25-.36l-.07-.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24,17.36c.11-.02,.19-.11,.21-.22,.07-.51,.3-1.98,.54-2.78,.06-.18-.09-.36-.28-.34l-.36,.03h0s-.5,1.3-.62,3.07c-.01,.17,.15,.31,.31,.27l.2-.04Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.32,
    cy: 26.91,
    rx: 4.27,
    ry: 4.18,
    style: {
      fill: "#c1966f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,22.79c-2.35,0-4.27,1.88-4.27,4.18s1.92,4.18,4.27,4.18,4.27-1.88,4.27-4.18c0-2.3-1.92-4.18-4.27-4.18Z",
    style: {
      fill: "#c1966f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.09,10.97s0,0,0,0c.09,.04,.12,.06,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.47,17.24c-.13,.3-.4,6.08-.4,7.09,0,.1-.06,.2-.16,.24l-.63,.28c-.28,.21-.28,.42-.28,.42l.07,1.04c0,.35,.36,.56,.36,.56l.78,.07c.36,.28,.93,0,.93,0l.21-.14c.18,.18,3.63,.46,4.6,.54,.14,.01,.26-.09,.28-.23,.74-5.37,4.88-4.83,4.88-4.83,4.7-.21,4.84,4.32,4.84,4.32,0,.39,.11,.61,.19,.73,.05,.07,.13,.1,.21,.1l41.61-.1c.57,.07,.64-.49,.64-.49,.57-3.48,2.85-4.25,2.85-4.25,3.56-1.18,5.48,.86,5.68,1.09,.01,.01,.02,.03,.03,.05l.68,1.26s.02,.05,.03,.08l.2,1.19s0,.03,0,.04v.41c0,.15,.12,.26,.26,.26h2.17s.08,0,.12-.03l.98-.48c.07-.03,.12-.09,.14-.17,.17-.72,.11-1.97,.11-1.97h0c0-.4-.19-.52-.26-.55-.01,0-.03,0-.04-.01l-.58-.13c-.15-.03-.24-.19-.19-.33,.19-.64-.07-1.97-.07-1.97-.21-1.25-.57-1.39-.57-1.39-.19-.24-.53-.75-.62-.88-.01-.02-.03-.04-.05-.05-1.24-1.1-5.32-1.51-5.32-1.51-.43,.07-.64-.35-.64-.35-.34-.25-.55-.23-.67-.17-.09,.05-.2,.02-.27-.05-1.03-.96-6.31-5.81-6.48-5.96-.15-.06-.45-.18-.51-.11-.03,.04-4.38-3.48-4.43-3.49l-1.51-6.78C46.14-.53,2.09,.22,1.71,.6c-.6,.6-.35,11.97-.38,12.05m49.7-1.39h0s3.44-.07,4.47,.48c.02,0,.03,.02,.04,.03,.25,.19,2.88,2.18,3.49,3.11l.21,2.37v.35l-8.1-.41c-.14,0-.24-.12-.25-.25l-.24-4.96s0-.06-.02-.09c-.07-.12-.12-.55,.4-.61ZM2.46,1.73H38.61V10.38H2.46V1.73Zm0,13.18c0-.84,.06,2.1-.02,2.62-.02,.11-.1,.2-.21,.22l-.2,.04c-.17,.03-.33-.1-.31-.27,.07-.98,.05-1.79,.03-2.32-.02-.36,.27-.66,.64-.66h.07m66.22,7.16l-19.54-.05v4.94h-4.52v-4.95h-.75s0,4.95,0,4.95h-4.52v-4.97l-37.18-.1c-.21,0-.33-.23-.22-.4l.1-.17c.05-.08,.13-.13,.23-.13l37.07,.1V3.61h4.52V20.92h.75s0-17.32,0-17.32h4.52V20.94l19.47,.05c.11,0,.2,.07,.24,.16l.07,.17c.07,.17-.06,.36-.25,.36Zm2.75,1.81h0s-.69,.26-1.19,.2c-.13-.02-.23-.14-.23-.27l.06-2.94c0-.09,.04-.16,.11-.21,.16-.11,.48-.26,.86-.13,.02,0,.04,.01,.05,.02,.11,.07,.54,.41,.54,1.8,0,0,.07,1.18-.21,1.53Z",
    style: {
      fill: "#161513"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.63 20.93 44.63 21.62 49.15 21.63 49.15 20.94 44.63 20.93",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.36 20.91 39.36 21.61 43.88 21.62 43.88 20.92 39.36 20.91",
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.791f5dcab78812b7dc301f62f7189235.svg";
export { ForwardRef as ReactComponent };